// extracted by mini-css-extract-plugin
export default {"anchor-link":"AnchorLink_anchor-link__kHS+O"};